import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      color: theme.palette.primary.main,
      fontSize: 16,
      fontWeight: 500,
      cursor: 'pointer',
    },
  };
});

type LinkButtonProps = {
  action?: () => void;
  className?: string;
  children: JSX.Element | JSX.Element[];
};

/**
 * Clickable button-like element, with link-like style.
 *
 * @param {Function} action - action on click
 * @param {string} [className] - optional class name
 * @param {JSX.Element} children - content
 *
 * @returns {JSX.Element}
 */
export const LinkButton = ({ action, className, children }: LinkButtonProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={clsx(styles.root, className)} onClick={action}>
      {children}
    </div>
  );
};
